// Villes principales desservies par METERIS depuis l'atelier de Meaux.
// Pour chaque ville : éléments uniques (distance, code postal, secteurs typiques,
// repères locaux) afin d'éviter le duplicate content sur les pages d'atterrissage.

const locations = {
  meaux: {
    name: 'Meaux',
    postalCode: '77100',
    distanceKm: 0,
    population: '55 000',
    intro:
      "Siège historique de METERIS, l'atelier de Meaux (8 rue Georges Claude) est notre point d'ancrage en Seine-et-Marne. Nous intervenons quotidiennement chez les PME et collectivités du bassin meldois.",
    sectors:
      "tissu local mêlant industries (Lagardère Travel Retail, plateformes logistiques), services publics (Mairie, Pays de Meaux), professions libérales et commerces du centre-ville",
    landmarks: ["Cathédrale Saint-Étienne", "Marché de Meaux", "Pays de Meaux"],
    nearbyHighway: "A4 (Paris-Strasbourg) et N3",
  },
  chelles: {
    name: 'Chelles',
    postalCode: '77500',
    distanceKm: 25,
    population: '54 000',
    intro:
      "Chelles, deuxième ville la plus peuplée de Seine-et-Marne, concentre un dynamisme tertiaire et industriel important. METERIS y intervient régulièrement chez des entreprises du Faubourg de Paris et de la zone de la Trentaine.",
    sectors: "PME du tertiaire, artisans, commerces et écoles privées",
    landmarks: ["Faubourg de Paris", "Zone d'activité de la Trentaine", "RER E"],
    nearbyHighway: "A4 et A104 (Francilienne)",
  },
  'lagny-sur-marne': {
    name: 'Lagny-sur-Marne',
    postalCode: '77400',
    distanceKm: 22,
    population: '21 000',
    intro:
      "Lagny-sur-Marne est un pôle économique majeur de l'est francilien, à mi-chemin entre Paris et Marne-la-Vallée. Nos équipes accompagnent les TPE/PME du centre-ville et de la zone d'activités du Pré-Levrier.",
    sectors: "professions libérales (médical, juridique), commerces, PME industrielles",
    landmarks: ["Centre historique", "Hôpital de Lagny", "Gare RER A"],
    nearbyHighway: "A4 et A104",
  },
  coulommiers: {
    name: 'Coulommiers',
    postalCode: '77120',
    distanceKm: 28,
    population: '14 500',
    intro:
      "Coulommiers, capitale du Brie, est entourée d'un tissu rural d'artisans, exploitants agricoles et PME agroalimentaires. METERIS intervient régulièrement sur les ZAE du sud-est de Meaux.",
    sectors: "agroalimentaire, artisanat, exploitations agricoles, professions libérales",
    landmarks: ["Marché du Brie", "Hôpital de Coulommiers"],
    nearbyHighway: "N34",
  },
  'marne-la-vallee': {
    name: 'Marne-la-Vallée',
    postalCode: '77700',
    distanceKm: 30,
    population: '300 000 (zone)',
    intro:
      "Marne-la-Vallée et son écosystème (Val d'Europe, Champs-sur-Marne, Bussy-Saint-Georges) regroupent un grand nombre de sièges, parcs d'activité et campus universitaires. METERIS y est présent pour ses clients industriels et tertiaires.",
    sectors: "sièges sociaux, parcs d'activités, universités, hôtellerie (Disneyland Paris)",
    landmarks: ["Val d'Europe", "Cité Descartes", "Disneyland Paris"],
    nearbyHighway: "A4, A104, RER A",
  },
  'roissy-en-brie': {
    name: 'Roissy-en-Brie',
    postalCode: '77680',
    distanceKm: 35,
    population: '23 000',
    intro:
      "Roissy-en-Brie est un nœud du sud de la Seine-et-Marne, proche de la N104 et du parc de la Brosse. METERIS y intervient chez des PME de service et des collectivités locales.",
    sectors: "PME tertiaires, collectivités, ESS",
    landmarks: ["Parc de la Brosse", "Centre commercial Roissy"],
    nearbyHighway: "N104, A4",
  },
  'mitry-mory': {
    name: 'Mitry-Mory',
    postalCode: '77290',
    distanceKm: 25,
    population: '20 000',
    intro:
      "Mitry-Mory accueille de nombreuses plateformes logistiques liées à l'aéroport de Roissy-Charles-de-Gaulle. METERIS y déploie infogérance et téléphonie pour les acteurs de la logistique et de l'industrie.",
    sectors: "logistique, transport, industrie, services aéroportuaires",
    landmarks: ["Aéroport CDG (proximité)", "Zone industrielle Mitry"],
    nearbyHighway: "A104, A1",
  },
  'claye-souilly': {
    name: 'Claye-Souilly',
    postalCode: '77410',
    distanceKm: 18,
    population: '12 500',
    intro:
      "Claye-Souilly, à mi-chemin entre Meaux et Paris sur la N3, est un carrefour pour les artisans et PME du secteur. METERIS y intervient sur l'infogérance, l'impression et la cybersécurité.",
    sectors: "artisanat, PME industrielles, commerces",
    landmarks: ["RD3 (ex-N3)", "Zone d'activité"],
    nearbyHighway: "A104, RD3",
  },
};

export default locations;
